import { generateSeperatorTags } from '@/src/pages/channel_list/components/ShopCard/items/rich_text_items/utils';

export default class ShopAvgSpendRichTextItemModel {
  originalData: any = null;
  constructor(data) {
    this.originalData = data;
  }
  richContents(landscapeJSXElements, landscapeRichTextContents) {
    const contents: any = [];
    const textName = this.originalData?.shopAvgSpend;

    const seperatorTags = generateSeperatorTags();
    if (landscapeJSXElements.length > 0 || landscapeRichTextContents.length > 0) {
      contents.push(...seperatorTags);
    }
    const baselineOffset = Mach.env.isIOS ? 0.5 : undefined;
    if (textName) {
      contents.push({
        type: 'text',
        text: `${textName}`,
        color: '#4D4D4D',
        fontSize: 12,
        fontFamily: 'KeeTa-Regular',
        lineHeight: 18,
        baselineOffset,
      });
    }
    return contents;
  }
}
